import React from "react";
import { useSelector } from "react-redux";
import UMLanding from "../../components/upgrade-membership/UMLanding";
import { selectUser } from "../../components/auth/auth.selector";

const UpgradeMembership = () => {
  const userInfoData = useSelector(selectUser);

  return <UMLanding userInfoData={userInfoData} />;
};

export default UpgradeMembership;
